import React from "react";
import styles from "./AlertsList.module.css";

const AlertsList = ({
  title = "Alerts",
  icon,
  items = [],
  loading = false,
  error = null,
  emptyMessage = "No alerts",
  maxHeight = 420,
  onItemClick,
}) => {
  const hasData = Array.isArray(items) && items.length > 0;
  const isClickable = typeof onItemClick === "function";

  // Centered wrapper for loading / error / empty states
  const centeredState = {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    textAlign: "center",
    minHeight: 120,
    padding: "24px 16px",
    color: "var(--text-secondary, #6b7280)",
    fontSize: 14,
  };

  const renderContent = () => {
    if (loading && !hasData) {
      return (
        <div className={styles.state} style={centeredState}>
          <div className={styles.spinner} />
        </div>
      );
    }

    if (error && !hasData) {
      return (
        <div
          className={`${styles.state} ${styles.error}`}
          style={{ ...centeredState, color: "var(--color-text)" }}
        >
          {error}
        </div>
      );
    }

    if (!hasData) {
      return (
        <div className={styles.state} style={centeredState}>
          {emptyMessage}
        </div>
      );
    }

    return (
      <ul className={styles.list} role="list">
        {items.map((item) => {
          const colorClass =
            styles[`swatch_${item.color}`] || styles.swatch_gray;

          return (
            <li
              key={item.id}
              className={`${styles.item} ${
                isClickable ? styles.itemClickable : ""
              }`}
              onClick={isClickable ? () => onItemClick(item) : undefined}
            >
              <span className={`${styles.swatch} ${colorClass}`} />
              <p className={styles.message}>{item.message}</p>
              <span className={styles.date}>{item.date}</span>
              <span className={styles.statusIcon}>{item.icon}</span>
            </li>
          );
        })}
      </ul>
    );
  };

  return (
    <div className={styles.card}>
      <div className={styles.header}>
        <div className={styles.headerLeft}>
          {icon && (
            <span className={styles.icon} aria-hidden="true">
              {icon}
            </span>
          )}
          <h3 className={styles.title}>{title}</h3>
        </div>
      </div>

      <div
        className={styles.body}
        style={{
          maxHeight,
          minHeight: 140,
          display: "flex",
          flexDirection: "column",
        }}
      >
        {renderContent()}
      </div>
    </div>
  );
};

export default AlertsList;
